module.exports = __webpack_public_path__ + "img/tailwind-elements.9d6feaa8.jpg";